import React, { Component } from 'react';
import { Dropbox } from 'dropbox';

import ErrorManager from './../Core/ErrorManager';

class FileList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };
    this.delete = this.delete.bind(this);
    this.load(props.path);
  }

  componentDidUpdate(prevProps) {
    if (this.props.path !== prevProps.path) {
      this.load(this.props.path);
    }
  }

  load(path) {
    var dbx = new Dropbox({ accessToken: 'Y2SJaWmFtwAAAAAAAAAABhL-2SP8bRmwASUCtXvUkkc64zWMuD7oMlj1vdmlJLl6' });
    dbx
      .filesListFolder({ path: path })
      .then((response) => {
        let entries = [];
        let requests = [];
        response.entries.forEach((e) => {
          let request = dbx.filesGetTemporaryLink({
            path: e.path_display,
          });
          requests.push(request);
        });
        Promise.all(requests).then((data) => {
          data.forEach((response) => {
            entries.push(response);
          });
          this.setState({
            files: entries,
          });
        });
      })
      .catch((error) => {
        if (error.status == 409) {
          this.setState({
            files: [],
          });
        } else {
          ErrorManager.Instance.Handle('Impossible de récupérer les fichiers.');
        }
      });
  }

  delete(path) {
    if (!window.confirm('Etes-vous sûr de vouloir supprimer ce fichier ?')) return;
    var dbx = new Dropbox({ accessToken: 'Y2SJaWmFtwAAAAAAAAAABhL-2SP8bRmwASUCtXvUkkc64zWMuD7oMlj1vdmlJLl6' });
    dbx
      .filesDelete({
        path: path,
      })
      .then((response) => {
        this.load(this.props.path);
      })
      .catch((error) => {
        ErrorManager.Instance.Handle('Impossible de supprimer le fichier.');
      });
  }

  render() {
    let files = [];
    //{e.metadata.size}kB - {new Date(e.metadata.client_modified).toLocaleDateString()}
    this.state.files.forEach((e) => {
      files.push(
        <div className='mb-1 bg-light-blue px-2 py-1' style={{ width: 'fit-content' }} key={e.link}>
          <a href={e.link} className='text-blue'>
            {e.metadata.name}
          </a>
          <span
            className='fa fa-times ml-2 text-blue'
            onClick={(ev) => {
              ev.preventDefault();
              this.delete(e.metadata.path_lower);
            }}
          />
        </div>,
      );
    });
    return <div className={this.state.files.length > 0 ? 'py-3' : ''}>{files}</div>;
  }
}

export default FileList;



// WEBPACK FOOTER //
// ./src/Components/FileList.js